import EditorVM from './editor-vm'

export default {
  init(node) {
    const params = $('#article-json').val()

    ko.applyBindingsWithValidation(
      new EditorVM(params),
      node,
      //
      // Following options explained here:
      // https://github.com/Knockout-Contrib/Knockout-Validation/wiki/Configuration
      //
      {
        insertMessages: false,
        errorsAsTitle: true,
        decorateInputElement: true,
        parseInputAttributes: true,
        messagesOnModified: true,
        errorElementClass: 'error',
        errorMessageClass: 'error',
        decorateElementOnModified: true,
        decorateElement: true,
        grouping: { deep: true, observable: true, live: true },
      }
    )
  }
}
